export default __webpack_public_path__ + "static/media/Queen_of_hearts.bdbdcd36.svg";